export default {
  languageText: '简体中文',
  'header.activityIncome': '新客活动收益',
  'header.message': '消息',
  'header.userCenterTip': '点击进入用户中心',
  'header.userCenter': '用户中心',
  'header.logout': '退出登录',
  'header.loginOrRegister': '登录 / 注册',
  'header.commonEntries': '常用入口',
  'footer.address': '公司地址：杭州市余杭区余杭街道文一西路1818-2号中国人工智能小镇6-702',
  'footer.phone': '咨询热线：0571-86395960',
  'footer.email': '联系邮箱：cd@uifox.com.cn',
  'footer.products': '产品',
  'footer.about': '关于我们',
  'footer.company': '公司介绍',
  'footer.follow': '公众号',
  'message.unread': '{count}条未读',
  'message.next': '下一条',
  'message.noUnread': '暂无未读消息',
  'message.empty': '暂无消息',
  'message.viewMore': '查看更多',
  'message.markAllRead': '一键已读',
  'message.close': '关闭',
  'home.dataSubmission': '数据发送',
  'home.logisticsTracking': '运价查询 · 物流跟踪',
  'home.rpaRobot': 'RPA机器人',
  'home.serviceScope': '服务范围',
  'home.consultGift': '咨询有礼',
  'home.shPremanifestTitle': '上海-预配舱单',
  'home.shPremanifestText': '快速回执 智能审核',
  'home.qdPremanifestTitle': '青岛-预配舱单',
  'home.qdPremanifestText': '快速回执 智能审核',
  'home.emAciText': '提供8000 code，<br/>安全高效，一键发送',
  'home.afrTitle': 'AFR发送',
  'home.afrText': '提供AFR code,<br/>快速回执，精准高效',
  'home.amsTitle': 'AMS发送',
  'home.amsText': '提供SCAC code，<br/>无需 FMC Bond，安全简单',
  'home.isfTitle': 'ISF发送',
  'home.isfText': '提供SCAC code，<br/>无需 FMC Bond，安全简单',
  'home.icsTitle': 'ICS发送',
  'home.icsText': '安全简单',
  'home.freightRateText': '覆盖全球国际海运费<br/>一站式实时查询',
  'home.cargoTrackingTitle': '箱货跟踪',
  'home.cargoTrackingText': '全域管理 周期预测<br/>支持网页版、微信订阅提醒',
  'home.fullLinkTrackingTitle': '全链路跟踪',
  'home.fullLinkTrackingText': '全程可视化跟踪<br/>关键节点实时推送',
  'home.rpaDigitalEmployeeTitle': '企业的数字员工',
  'home.rpaDigitalEmployeeText': '集成各种先进技术，用机器人代替<br/>人力操作，降本增效',
  'home.rpaAutomationTitle': '应用程序的自动化',
  'home.rpaAutomationText': '可以实现任何桌面应用、网页程序<br/>的自动化',
  'home.rpaInputAutomationTitle': '鼠标键盘的自动化',
  'home.rpaInputAutomationText': '可以控制鼠标和键盘，替代人力完<br/>成繁琐的流程',
  'agent.sinotrans': '上海中外运',
  'agent.sinounion': '上海中联',
  'agent.huagang': '上海华港',
  'agent.penavico': '上海外代',
  'agent.zhenhua': '上海振华',
  'agent.minsheng': '上海民生',
  'agent.hanghua': '上海航华',
  'agent.shunde': '上海顺德',
  'agent.penghua': '上海鹏华',
  'agent.penghai': '上海鹏海',
  'agent.sipg': '上港联合',
  'agent.oocl': '东方海外',
  'agent.xinhai': '新海',
  'agent.jincheng': '锦诚'
}
